import { normalizeText } from './text'

const UNIT_ALIASES: Readonly<Record<string, string>> = {
  平方米: 'm2',
  平方公尺: 'm2',
  立方米: 'm3',
  立方公尺: 'm3',
  米: 'm',
  公尺: 'm',
  千克: 'kg',
  公斤: 'kg',
  吨: 't',
  公吨: 't',
  升: 'l',
}

/** Normalizes common BOQ units without changing their displayed source text. */
export function normalizeUnit(value: unknown): string {
  let unit = normalizeText(value).replace(/\s+/gu, '')
  if (!unit) return ''

  unit = unit
    .replace(/㎡/gu, 'm2')
    .replace(/㎥/gu, 'm3')
    .replace(/m(?:\^|\*)?2$/u, 'm2')
    .replace(/m(?:\^|\*)?3$/u, 'm3')

  return UNIT_ALIASES[unit] ?? unit
}
